import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CameraIcon, VideoIcon } from "../../utils/SvgComponents";
import PageHeading from "../common/PageHeading";
import CustomCard from "../common/card/Card";
import Photos from "../photos/Photos";
import { Video } from "lucide-react";
import Videos from "../videos/Videos";
import { apiHandler } from "../../utils/apiHandler";
import { EVENT_BASEURL } from "../../utils/Constants";

const Gallery = () => {
  const { id } = useParams();
  const location = useLocation();
  const [response, setResponse] = useState([]);

  const [backgroundImageWeb, setBackgroundImageWeb] = useState([]);
  const [backgroundImageMob, setBackgroundImageMob] = useState([]);
  const [isSlideIn, setIsSlideIn] = useState(false);
  const [isPhotosRendered, setIsPhotosRendered] = useState(false);
  const [isVideosRendered, setIsVideosRendered] = useState(false);
  const [currentImageIndexWeb, setCurrentImageIndexWeb] = useState(0);
  const [currentImageIndexMob, setCurrentImageIndexMob] = useState(0);
  const [SlideInvideo, setSlideInforVideos] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(true);
  const pathParts = location.pathname.split("/").filter(Boolean);
  const username = pathParts[0];

  const navigate = useNavigate();
  let NewUsername = "";

  const pathArray = window.location.pathname.split("/").filter(Boolean);

  if (pathArray.includes("Login")) {
    // Handle special case when URL contains "Login"
    NewUsername = pathArray[1];
  } else {
    NewUsername = pathArray[0]
  }

  let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
  const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
  console.log(newImgUrl);
  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth <= 768);
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  useEffect(() => {
    const fetchGallery = async () => {
      try {

        const res = await apiHandler.post("/guest/fetch-feature", {
          _id: id,
          category: "Gallery"
        });
        console.log(res);
        if (res) {
          setResponse(res);
          setBackgroundImageWeb(res.basicDetails.sliderImgsWeb);
          setBackgroundImageMob(res.basicDetails.sliderImgsMob);
        }
      } catch (err) {
        console.error("Guest login error:", err);
      }
    };

    if (response?.length === 0) {
      fetchGallery();
    }
  }, [])


  useEffect(() => {
    if (window.location.pathname === "/Gallery") {
      localStorage.setItem("photos_page", "");
      localStorage.setItem("hasVisitedPhotosPage", "");
    }
  }, [window.location.pathname])

  const handleSlideIn = () => {
    setIsPhotosRendered(true)
    if (!isSlideIn) {
      window.history.pushState({ isSlideIn: true }, "", `/${username}/photos/${id}`);
      localStorage.setItem("photos_page", true);
    } else {

      window.history.back();
      return;
    }
    console.log("runing all code")
    setIsSlideIn(!isSlideIn);
  };

  useEffect(() => {
    const handlePopState = () => {
      setIsSlideIn(false);
      if (window.location.pathname === "/Gallery") {
        localStorage.setItem("photos_page", "");
      }

    };

    window.addEventListener('popstate', handlePopState);


    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isSlideIn]);

  const handleSlideInVideo = () => {
    setIsVideosRendered(true)
    if (!SlideInvideo) {
      window.history.pushState({ SlideInvideo: true }, "", `/${username}/videos/${id}`);
    } else {
      window.history.back();
      return;
    }
    console.log("runing all code")
    setSlideInforVideos(!SlideInvideo);
  };

  useEffect(() => {
    const handlePopState = () => {
      if (SlideInvideo) {
        setSlideInforVideos(false);
      }
    };

    console.log("useEffect");
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [SlideInvideo]);

  useEffect(() => {
    if (!isMobile) {
      const interval = setInterval(() => {
        setCurrentImageIndexWeb((prev) =>
          prev === backgroundImageWeb.length - 1 ? 0 : prev + 1
        );
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [isMobile, backgroundImageWeb.length]);

  // Mobile background slider
  useEffect(() => {
    if (isMobile) {
      const interval = setInterval(() => {
        setCurrentImageIndexMob((prev) =>
          prev === backgroundImageMob.length - 1 ? 0 : prev + 1
        );
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [isMobile, backgroundImageMob.length]);


  return (
    <div
      id="home"
      style={{
        zIndex: "9999999999",
        backgroundColor: "white",
        position: "relative",
      }}
    >
      <div
        className={`${isSlideIn ? "translate-x-0" : "translate-x-full"
          } fixed top-0 right-0 w-full h-full bg-black/70 z-[100] `}
        style={{
          opacity: isSlideIn ? 1 : 0,
          minHeight: "100svh !important",
          transition: "transform 500ms ease-in-out, opacity 500ms ease-in-out",
        }}
      >
        <div className="">
          {
            isPhotosRendered && <Photos closePhotos={() => setIsSlideIn(true)} />

          }
        </div>
      </div>
      <div
        className={`${SlideInvideo ? "translate-x-0" : "translate-x-full"
          } fixed top-0 right-0 w-full h-full bg-black/70 z-[100] `}
        style={{
          opacity: SlideInvideo ? 1 : 0,
          minHeight: "100svh !important",
          transition: "transform 500ms ease-in-out, opacity 500ms ease-in-out",
        }}
      >
        <div className="">
          {isVideosRendered && <Videos />}
        </div>
      </div>

      <div className="hidden sm:block h-dvh">

        <div className="relative w-screen h-screen overflow-hidden">
          <div className="col-span-5 relative h-screen overflow-hidden">
            {backgroundImageWeb?.length > 0 &&
              backgroundImageWeb.map((img, index) => (
                <img
                  src={newImgUrl + img}
                  className={`w-full h-full relative z-[-1] object-cover crossFade__image ${currentImageIndexWeb === index ? 'crossFade__image--active' : ''
                    }
                            transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                    }
                            `}
                  onLoad={() => setIsImageLoaded(false)}

                  alt=""
                />
              ))}

          </div>
          <div className="absolute inset-0 ms-auto pt-10 flex flex-col bg-black/70 max-w-[450px] h-full item-center justify-center">
            <PageHeading title={"Our Gallery"} backTo={`/${username}/`} color={true} />
            <div className="py-10 flex flex-col justify-center items-center gap-[55px] mx-[80px]">
              <div
                className="w-full bg-white rounded-3xl overflow-hidden border-[3px] border-white cursor-pointer"
                onClick={handleSlideIn}
              >
                <div clicked={() => { }}>
                  <div className="flex justify-between items-center whiteripple">
                    <div className="flex-1">
                      <div className="w-full aspect-[5/6] overflow-hidden">
                        <img src={response?.basicDetails?.photosBg ? `${newImgUrl + response.basicDetails.photosBg}` : ""}
                          onLoad={() => setIsImageLoaded(false)}
                          className={`transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                            }`}
                          alt="" />

                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="mx-auto flex flex-col items-center justify-center mt-2">
                        <CameraIcon fill="#262626" width="65" height="65" />
                        <h5 className="text-[#262626] font-semibold text-[17px] px-2 common-font mt-[2px]">
                          Photos
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="w-full bg-white rounded-3xl border-[3px] border-white overflow-hidden cursor-pointer"
                onClick={handleSlideInVideo}
              >
                <CustomCard clicked={() => { }}>
                  <div className="flex justify-between items-center whiteripple">
                    <div className="flex-1">
                      <div className="w-full aspect-[5/6] overflow-hidden">
                        <img src={response?.basicDetails?.videosBg ? `${newImgUrl + response.basicDetails.videosBg}` : ""}
                          onLoad={() => setIsImageLoaded(false)}
                          className={` transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                            }`}
                          alt="" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="mx-auto flex flex-col items-center justify-center mt-2">
                        <VideoIcon fill="#262626" width="65" height="65" />
                        <h5 className="text-[#262626] text-center font-semibold text-[17px] px-2 mt-[2px]">
                          Videos
                        </h5>
                      </div>
                    </div>
                  </div>
                </CustomCard>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sm:hidden flex flex-col justify-between  animate-slide-bg h-dvh">
        <div className="relative h-screen overflow-hidden">

          {backgroundImageMob?.length > 0 &&
            backgroundImageMob.map((img, index) => (
              <img
                src={newImgUrl + img}
                className={`w-full h-full relative z-[-1] object-cover crossFade__image ${currentImageIndexMob === index ? 'crossFade__image--active' : ''
                  } transition-all duration-500
                  ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"}
                  `}
                alt=""
              />
            ))}
          <div
            className="top-0 w-full h-full py-[30px] px-[30px] opacity-90 absolute flex flex-col justify-center items-center text-center"
            style={{
              background:
                "linear-gradient(0deg, rgba(0,0,0,0.9) 0%, rgba(59,59,59,0.4) 50%, rgba(0,0,0,0.9) 100%)",
            }}
          >
            <div className="w-full h-full flex justify-center items-center border-[3px] border-white text-center">
              <h1 className="style-script-regular text-white text-[60px] font-['Baby_Giovani_Script'] m-0 p-0">
                Gallery
              </h1>
            </div>
          </div>
        </div>
        <div className="flex justify-around items-center gap-[1.25rem] m-[1rem]">
          <div className="relative w-full " onClick={handleSlideIn}>
            <CustomCard>
              <img
                src={response?.basicDetails?.photosBg ? `${newImgUrl + response.basicDetails.photosBg}` : ""}
                className={`object-cover w-full aspect-[2/3] relative z-[-1] transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                  }`}
                alt=""
              />
              <div className="absolute top-0 w-full h-full flex flex-col justify-center items-center text-center bg-black/35 ">
                <span className="w-full h-full flex flex-col justify-center items-center text-center mt-[6px]">
                  <CameraIcon fill="white" />
                  <h5 className="text-white common-font text-[16px] mt-[2px]">
                    Photos
                  </h5>
                </span>
              </div>
            </CustomCard>
          </div>
          <div className="relative w-full " onClick={handleSlideInVideo}>
            <CustomCard>
              <img
                src={response?.basicDetails?.videosBg ? `${newImgUrl + response.basicDetails.videosBg}` : ""}
                onLoad={() => setIsImageLoaded(false)}
                className={`object-cover w-full aspect-[2/3] relative z-[-1] transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
                  }`}
                alt=""
              />
              <div className="absolute top-0 w-full h-full flex flex-col justify-center items-center text-center bg-black/35">
                <span className="w-full h-full flex flex-col justify-center items-center text-center mt-[6px]">
                  <VideoIcon fill="white" />
                  <h5 className="text-white common-font text-[16px] mt-[2px]">
                    Videos
                  </h5>
                </span>
              </div>
            </CustomCard>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
